import {Layout,} from "antd";
import React, {useEffect, useMemo, useState} from "react";
import {Contain} from "@components/layout";
import {Helmet as Head} from "react-helmet-async";
import usePreferences from "@hooks/usePreferences";
import {IssueFiltersPaginatedQuery, useGetIssuesQuery} from "@mwServices/Issue";
import IssuesFiltersDrawer from "@mwPages/issues/IssuesFiltersDrawer";
import useSearchView from "@hooks/useSearchView";
import {isEqual} from "underscore";
import {TopnavSearchDropdown} from "@components/topnav-search-dropdown";
import IssuesResults from "@mwPages/issues/IssuesResults";
import {formatNumber} from "@lib/format";

export const IssuesPageContent = ({inputFilters}) => {
    const { itemCount } = usePreferences();
    const [selectedComicIds, setSelectedComicIds] = useState<number[]>([]);
    const [search, setSearch] = useState('');

    const defaultFilters = useMemo(() => ({
        query: '',
        series: undefined,
        barcode: undefined,
        sort: 0,
        showVariants: false, //This means include variants in the results, not only variants.
        inCollection: false,
        isHot: false,
        isKey: false,
        isRare: false,
        multipleDateRanges: undefined,
        ...inputFilters,
    }), [inputFilters]);

    const [issueParams, setIssueParams] = useState<IssueFiltersPaginatedQuery>({
        filters: { ...defaultFilters },
        page: 1,
        perPage: itemCount,
    });

    useEffect(() => {
        if(search !== issueParams.filters.query){
            setIssueParams({ ...issueParams, page: 1, filters: { ...issueParams.filters, query: search ? search : '' } });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    useEffect(() => {
        if(issueParams.filters.query && search !== issueParams.filters.query){
            setSearch(issueParams.filters.query);
        }
    }, [issueParams.filters.query]);

    useEffect(() => {
        setIssueParams({
            filters: { ...defaultFilters },
            page: 1,
            perPage: itemCount,
        });
    }, [defaultFilters]);

    const issueQuery = useGetIssuesQuery(issueParams);

    const {issueData, pagination}  = useMemo(() => {
        if(issueQuery.data) return {
            issueData: issueQuery.data,
            pagination: issueQuery.data.pagination,
        };
        return { issueData: null, pagination: null };
    }, [issueQuery]);

    return (
        <>
            <TopnavSearchDropdown query={search} isOnPage={true} />
            <Contain>
                <IssuesResults
                    issueQuery={issueQuery}
                    issuesTitle={<span>{pagination && formatNumber(pagination.total_items)} Issues</span>}
                    infoModalData={null}
                    defaultFilters={defaultFilters}
                    issueParams={issueParams}
                    setIssueParams={setIssueParams}
                    search={search}
                    setSearch={setSearch}
                    selectedComicIds={selectedComicIds}
                    setSelectedComicIds={setSelectedComicIds}
                    filterDrawer={
                        <IssuesFiltersDrawer
                            filters={issueParams.filters}
                            setFilters={(filters) => setIssueParams({...issueParams, page: 1, filters})}
                            defaultFilters={defaultFilters}
                        />
                    }
                    isSearchBarcode={false}
                    isSearchES={false}
                    useGridView={true}
                    useListView={true}
                    useListViewNoImages={false}
                    showIssueNotes={false}
                />
            </Contain>
        </>
    );
};


const IssuesPage = ({}) => {
    const { filters } = useSearchView();
    const [inputFilters, setInputFilters] = useState((filters && filters !== '') ? JSON.parse(atob(decodeURIComponent(filters))) : {});

    useEffect(() => {
        if(filters && filters !== ''){
            const decodedFilters = JSON.parse(atob(decodeURIComponent(filters)));
            if(!isEqual(decodedFilters, inputFilters)){
                setInputFilters(decodedFilters);
            }
        }
    }, [filters]);

    return (
    <Layout className="page issues-page">
      <Head>
        <title>Issues - CovrPrice</title>
      </Head>
        <IssuesPageContent inputFilters={inputFilters} />
    </Layout>
    );
};

export default IssuesPage;
